import React, { useMemo } from 'react'
import _isNil from "lodash/isNil"
import styles from "./styles.module.css";
import { PLAYER_NUMBER } from '../../../pages/GamePlay/types';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { getIsKukariScoreVisible } from '../../../store/selectors/ludoboardSelectors';

interface IKukari {
  kukari: {
    i : number
    isMovable: boolean
    playerNumber: PLAYER_NUMBER,
    score?: number
  }
}

const PlayerVsBorderColor = {
  [PLAYER_NUMBER.ONE]: "#ffffff",
  [PLAYER_NUMBER.TWO]: '#0179DF',
  [PLAYER_NUMBER.THREE]: '#9A252A',
  [PLAYER_NUMBER.FOUR]: '#2D890E'
}

function KukariScore({ kukari }: IKukari) {
  const isKukariScoreVisible = useSelector(getIsKukariScoreVisible)
  const { playerNumber } = kukari || {}
  const score = playerNumber !== PLAYER_NUMBER.ONE ? kukari.score : 0

  if (!isKukariScoreVisible || _isNil(score) || score <= 0) {
    return null
  }

  return (
    <div 
      className={clsx(styles.kukariScore, "fontSizeXs fontWeightBolder flex alignItemCenter justifyContentCenter")}
      style={{ borderColor: PlayerVsBorderColor[playerNumber] }}
    >
      {score}
    </div>
  )
}

export default KukariScore;